import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FileManagerService} from '../../../../modules/file-manager/file-manager.service';
import {DocumentFolderDataModel} from '../../../../models/document/document-folder-data.model';
import {IoTreeNodeModel} from '../../../../modules/imaging/models/io-tree-node.model';
import {IoTreeNodeTypeModel} from '../../../../modules/imaging/models/io-tree-node-type.model';
import {ITdoTreeItem} from '../../../../tdo-controls/common/tdo-tree/models/i-tdo-tree-item';

@Component({
  standalone: false,
  selector: 'app-tdo-organizer-restore-dialog',
  templateUrl: './tdo-organizer-restore.dialog.component.html',
  styleUrls: ['./tdo-organizer-restore.dialog.component.scss']
})
export class TdoOrganizerRestoreDialogComponent implements OnInit {
  libraryModels: DocumentFolderDataModel[] = [];
  lectureModels: DocumentFolderDataModel[] = [];

  libraryTreeData: IoTreeNodeModel[] = [];
  lectureTreeData: IoTreeNodeModel[] = [];

  private selectedFolder: IoTreeNodeModel;

  constructor(private dialogRef: MatDialogRef<TdoOrganizerRestoreDialogComponent>,
              private fileManagerService: FileManagerService) { }

  ngOnInit(): void {
    this.fileManagerService.getLibraryDocumentFolders().subscribe((res) => {
      this.libraryModels = res.LibraryFolders;
      this.libraryTreeData = this.getTreeData(this.libraryModels, IoTreeNodeTypeModel.Library);
      this.lectureModels = res.LectureFolders;
      this.lectureTreeData = this.getTreeData(this.lectureModels, IoTreeNodeTypeModel.Lecture);
    });
  }

  getTreeData(models: DocumentFolderDataModel[], type: IoTreeNodeTypeModel) {
    const tree: IoTreeNodeModel[] = [];

    const treeNode = new IoTreeNodeModel();
    const rootNodeData = models[0];
    treeNode.id = rootNodeData.DocumnetFolderId;
    treeNode.name = rootNodeData.FolderName;
    treeNode.type = IoTreeNodeTypeModel.Library;
    treeNode.isExpanded = true;
    tree.push(treeNode);

    const nonRootFolders = models.filter(p => p.DocumentFolderParentId !== null);

    for (const folder of nonRootFolders) {
      const childNode = new IoTreeNodeModel();
      childNode.id = folder.DocumnetFolderId;
      childNode.name = folder.FolderName;
      childNode.type = type;
      childNode.isExpanded = true;

      if (folder.DocumentFolderParentId === treeNode.id) {
        treeNode.children.push(childNode);
      } else {
        const parent = this.sortFoldersIntoFolders(treeNode, folder);
        parent.children.push(childNode);
      }
    }

    return tree;
  }

  sortFoldersIntoFolders(treeNode: IoTreeNodeModel, folder: DocumentFolderDataModel): IoTreeNodeModel {
    const node = treeNode.children.find(p => p.id === folder.DocumentFolderParentId);
    if (node) {
      return node;
    } else {
      for (const innerNode of treeNode.children) {
        const tmp = this.sortFoldersIntoFolders(innerNode, folder);
        if (tmp) {
          return tmp;
        }
      }
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.selectedFolder);
  }

  selectFolder(folder: IoTreeNodeModel) {
    this.selectedFolder = folder;
  }

  isItemSelected(item: ITdoTreeItem): boolean {
    return item === this.selectedFolder;
  }

  onItemSelected(event: ITdoTreeItem) {
    this.selectedFolder = event as IoTreeNodeModel;
  }
}
